import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";

export const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div className="bg-[#191713] border-y border-[#B8933F]/15 py-6 overflow-hidden" aria-hidden="true" data-testid="editorial-marquee">
      <div className="marquee-track">
        {[...items, ...items].map((word, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-serif italic text-2xl lg:text-3xl text-[#F7F3EC]/40 whitespace-nowrap px-8">{word}</span>
            <span className="w-1.5 h-1.5 rotate-45 bg-[#B8933F]/50 shrink-0" />
          </span>
        ))}
      </div>
    </div>
  );
};

export const TrustPlaceholder = () => {
  const { t } = useLang();
  return (
    <section className="bg-[#F7F3EC] py-16 lg:py-20" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="border border-dashed border-[#191713]/25 p-8 lg:p-10 flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-12">
            <h2 className="font-serif text-2xl text-[#191713] whitespace-nowrap">{t.trust.title}</h2>
            <p className="text-sm text-[#191713]/60 leading-relaxed max-w-2xl">{t.trust.body}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export const FinalCTA = () => {
  const { t } = useLang();
  return (
    <section className="bg-[#F7F3EC] pb-24 lg:pb-32" data-testid="final-cta-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="bg-[#191713] px-8 py-16 lg:px-20 lg:py-24 relative overflow-hidden">
            <div aria-hidden="true" className="absolute top-0 left-1/2 -translate-x-1/2 w-px h-16 bg-gradient-to-b from-[#B8933F] to-transparent" />
            <h2 className="font-serif text-[#F7F3EC] text-3xl sm:text-4xl lg:text-5xl max-w-3xl mx-auto text-center leading-tight">
              {t.finalCta.title}
            </h2>
            <p className="mt-6 text-[#9A9184] text-center max-w-xl mx-auto">{t.finalCta.body}</p>
            <div className="mt-10 flex flex-col sm:flex-row justify-center gap-4">
              <Link to="/contact" data-testid="final-cta-book-call" className="btn-gold">
                {t.finalCta.cta1} <ArrowRight size={16} />
              </Link>
              <Link to="/contact" data-testid="final-cta-start-project" className="btn-outline-light">
                {t.finalCta.cta2}
              </Link>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
